import React from 'react';
import CatalogPage from '../components/CatalogPage';

function CatalogStandalonePage() {
  return <CatalogPage />;
}

export default CatalogStandalonePage;

